import classNames from 'classnames';
import * as React from 'react';
import styles from './Link.module.scss.js';

var Link = React.memo(function (props) {
    var classNameLink = classNames(styles.link, styles[props.arrow], props.className);
    var classNameActionLink = classNames(styles.link, styles.actionLink, styles[props.arrow], props.className);
    return props.isActionLink ? (React.createElement("span", { className: classNameActionLink, onClick: props.onClick }, props.children)) : (React.createElement("a", { href: props.to, className: classNameLink, onClick: props.onClick }, props.children));
});

export { Link as default };
//# sourceMappingURL=Link.js.map
